import { render, staticRenderFns } from "./RisposteDialog.vue?vue&type=template&id=0b3ee4f7&scoped=true&"
import script from "./RisposteDialog.vue?vue&type=script&lang=js&"
export * from "./RisposteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ee4f7",
  null
  
)

export default component.exports